import React, { useEffect, useRef, useState } from "react";
import {
  addPayPalWalletNew,
  getAllSubscriptionApi,
  subscriptionProcessPayment,
  getCLinicById,
  myPaymentList,
  createPayPalOrderForServer,
  createStripeOrderForServer,
  createPayPalOrder,
} from "../hooks/services/api-services";
import {
  decryptAEStoJSON,
  encryptJSONtoAES,
  LoaderSpinner,
  toastEmitter,
} from "../utils/utilities";
import { API_RESPONSE, DEFAULT_PAGE_LENGTH } from "../utils/app-constants";
import parse from "html-react-parser";
import { useDispatch, useSelector } from "react-redux";
import TableLayout from "../components/layouts/table-layout";
import Modal from "../components/common/Model";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../hooks/routes/routes-constant";
import { setLoggedUserReducer } from "../hooks/redux/slice/logged-user";
import BreadCrum from "../components/common/BreadCrum";
import moment from "moment";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, } from "@stripe/react-stripe-js";
import StripePayment from "./StripePayment"
const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLIC_KEY
);

const PricingPlans = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isPlanLoading, setPlanIsLoading] = useState(false);
  const [isPaymentLoading, setIsPaymentLoading] = useState(false);
  const [planData, setPlanData] = useState([]);
  const { value } = useSelector((state) => state?.loggedUser);
  const userData = decryptAEStoJSON(value);
  const paymentModel = useRef(null);
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [pending, setPending] = useState(false);
  const [page, setPage] = useState(0);
  const [totalPayment, setTotalPayment] = useState(0);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_LENGTH);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [rowData, setRowData] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [remainingAmount, setRemainingAmount] = useState(0);
  const addbuttonClick = useRef();
  const stripeModalRef = useRef(null);

  /* ===== STATE ===== */
  const [clientSecret, setClientSecret] = useState(null);

  /* ===== PAYMENT METHOD ===== */
  const paymentMethodStatus = userData?.paymentMethod;
  const dispatch = useDispatch();
  const [modalContent, setModalContent] = useState({
    heading: "",
    paragraph: "",
    paragraphclassName: "",
  });
console.log("userData:", userData);
console.log("paymentMethodStatus:", paymentMethodStatus);

  const fetchSubscriptionData = async () => {
    const defaultPayload = {
      pageIndex: 0,
      pageSize: 100,
      searchText: "",
      direction: "asc",
      filterByFieldName: "id",
      status: 1,
      doctorId: 0,
      languageType: "en",
      subscriptionType: "CLINICSUBSCRIPTION",
    };
    setPlanIsLoading(true);
    try {
      const response = await getAllSubscriptionApi(defaultPayload);
      setPlanData(response?.data?.data?.subscriptionEntityResponseList || []);
    } catch {
      toastEmitter("error", API_RESPONSE?.MESSAGE_503);
    } finally {
      setPlanIsLoading(false);
    }
  };
  useEffect(() => {
    fetchSubscriptionData();
  }, [userData?.id]);

  const handleProcessPayment = async (payload, closeModal) => {
    if (!payload) return;
    try {
      setIsPaymentLoading(true);
      const response = await subscriptionProcessPayment(payload);
      if (response?.data?.status === 200) {
        // toastEmitter("success", response?.data?.message);
        setModalContent({
          heading: t("Payment Successful"),
          paragraph: t("Your payment via PayPal was completed successfully."),
          // paragraphclassName: "color-red-bold",
          paragraphclassName: "text-success fs-20 mt-1",
        });
        addbuttonClick?.current?.click();
        getClinicById();
        fetchPaymentList();
        if (closeModal) {
          paymentModel?.current?.click();
        }
        ;
      } else {
        toastEmitter(
          "error",
          response?.data?.message || "Something went wrong."
        );
      }
    } catch {
      toastEmitter("error", "Server error. Please try again later.");
    }
    finally {
      // setPlanIsLoading(false)
      setIsPaymentLoading(false);

      // Always stop loader
    }
  };

  const handleAddWallet = async (walletPayloadToUse, paymentPayloadToUse) => {
    if (!walletPayloadToUse?.orderId?.trim()) {
      return toastEmitter("error", "OrderId is mandatory!");
    }
    if (!walletPayloadToUse?.payerEmail?.trim()) {
      return toastEmitter("error", "Email is mandatory!");
    }
    if (walletPayloadToUse.amount === 0) {
      return toastEmitter("error", "Amount is mandatory!");
    }

    try {
      const response = await addPayPalWalletNew(walletPayloadToUse);
      if (response?.data?.status === 200) {
        // toastEmitter("success", response?.data?.message);
        await handleProcessPayment(paymentPayloadToUse);
      } else {
        toastEmitter(
          "error",
          response?.data?.message || "Something went wrong."
        );
      }
    } catch (error) {
      toastEmitter("error", "Server error. Please try again later.");
    }
  };


  const handleModalClose = () => {
    setClientSecret(null)
    setSelectedPlan(null)
    setRemainingAmount(0)
    navigate(ROUTES.SUBSCRIPTION);
  };

  const handleBuyNow = (plan) => {
    const planPrice = plan?.price || 0;
    const walletBalance = Number(userData?.walletBalance || 0);
    const difference = planPrice - walletBalance;

    setSelectedPlan(plan);
    setRemainingAmount(difference > 0 ? difference : 0);
    paymentModel?.current?.click();
  };


  // const handleFinalPay = async () => {
  //   if (!selectedPlan) return;

  //   setIsLoading(true);

  //   const payload = {
  //     amount: selectedPlan.price,
  //     currency: "usd",
  //     id: userData.id,
  //     userType: "CLINICSUBSCRIPTION",
  //     deductAmount: 0,
  //     orderId: "",
  //     payerEmail: userData.email,
  //     paymentMethodStatus: paymentMethodStatus
  //   };

  //   /* ================= PAYPAL ================= */
  //   if (paymentMethodStatus === 1) {
  //     try {
  //       const res = await createPayPalOrderForServer(payload);
  //       console.log("res,", res)

  //       if (res?.data?.data?.approvalUrl) {
  //         localStorage.setItem("pendingPlan", JSON.stringify(selectedPlan));
  //         window.location.href = res.data.data.approvalUrl;
  //       } else {
  //         toastEmitter("error", "PayPal approvalUrl missing");
  //       }
  //     } catch {
  //       toastEmitter("error", "PayPal init failed");
  //     } finally {
  //       setIsLoading(false);
  //     }
  //     return;
  //   }

  //   /* ================= STRIPE ================= */
  //   if (paymentMethodStatus === 2) {
  //     try {
  //       const res = await createStripeOrderForServer({
  //         ...payload,
  //         amount: Math.round(selectedPlan.price * 100),
  //       });

  //       const secret =
  //         res?.data?.clientSecret || res?.data?.data?.clientSecret;

  //       if (!secret) {
  //         toastEmitter("error", "Stripe clientSecret missing");
  //         return;
  //       }

  //       setClientSecret(secret);

  //       // close summary modal & open stripe modal
  //       paymentModel.current?.click();
  //       stripeModalRef.current?.click();
  //     } catch {
  //       toastEmitter("error", "Stripe init failed");
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   }
  // };

  const handleFinalPay = async () => {
  if (!selectedPlan) return;

  setIsLoading(true);

  const walletBalance = Number(userData?.walletBalance || 0);
  const planPrice = Number(selectedPlan.price || 0);

  /* ===== USE WALLET DIRECTLY ===== */
  if (walletBalance >= planPrice) {
    try {
      await subscriptionProcessPayment({
        id: userData.id,
        transactionId: "WALLET",
        payerEmail: userData.email,
        subscriptionId: selectedPlan.id,
        subscriptionDuration: selectedPlan.subscriptionDuration,
        walletAmountUsed: planPrice,
        userType: "CLINICSUBSCRIPTION",
      });

      await getClinicById();
      await fetchPaymentList();

      setModalContent({
        heading: t("Payment Successful"),
        paragraph: t("Subscription activated using wallet balance."),
        paragraphclassName: "text-success fs-20 mt-1",
      });

      paymentModel.current?.click();
      addbuttonClick.current?.click();

    } catch {
      toastEmitter("error", "Wallet payment failed");
    } finally {
      setIsLoading(false);
    }

    return;
  }

  /* ===== OTHERWISE PAYPAL / STRIPE ===== */
  const payload = {
    amount: selectedPlan.price,
    currency: "usd",
    id: userData.id,
    userType: "CLINICSUBSCRIPTION",
    deductAmount: 0,
    orderId: "",
    payerEmail: userData.email,
    paymentMethodStatus: paymentMethodStatus,
  };

  if (paymentMethodStatus === 1) {
    try {
      const res = await createPayPalOrderForServer(payload);

      if (res?.data?.data?.approvalUrl) {
        localStorage.setItem(
          "pendingPlan",
          JSON.stringify(selectedPlan)
        );
        window.location.href = res.data.data.approvalUrl;
      }
    } catch {
      toastEmitter("error", "PayPal init failed");
    } finally {
      setIsLoading(false);
    }

    return;
  }

  if (paymentMethodStatus === 2) {
    try {
      const res = await createStripeOrderForServer({
        ...payload,
        amount: Math.round(selectedPlan.price * 100),
      });

      const secret =
        res?.data?.clientSecret || res?.data?.data?.clientSecret;

      if (!secret) return;

      setClientSecret(secret);
      paymentModel.current?.click();
      stripeModalRef.current?.click();

    } finally {
      setIsLoading(false);
    }
  }
};

    const handlePayPalSuccess = async (paypalToken) => {
    const savedPlan = JSON.parse(localStorage.getItem("pendingPlan"));
    const walletBalance = Number(localStorage.getItem("walletBalance") || 0);
    if (!savedPlan || !paypalToken) {
      toastEmitter("error", "Missing payment details.");
      return;
    }
 
    const planPrice = savedPlan?.price || 0;
    const remaining = planPrice - walletBalance;
 
    const walletPayload = {
      id: userData?.id,
      amount: remaining,
      deductAmount: 0,
      orderId: paypalToken,
      payerEmail: userData.email,
      userType: "CLINICSUBSCRIPTION",
    };
 
    const paymentPayload = {
      id: userData?.id,
      transactionId: "",
      payerEmail:userData.email,
      subscriptionId: savedPlan?.id,
      subscriptionDuration: savedPlan?.subscriptionDuration,
      walletAmountUsed: planPrice,
      userType: "CLINICSUBSCRIPTION",
    };
 
    await handleAddWallet(walletPayload, paymentPayload);
 
    // Cleanup
    localStorage.removeItem("pendingPlan");
    localStorage.removeItem("paypalToken");
    localStorage.removeItem("walletBalance");
  };

  useEffect(() => {
  const params = new URLSearchParams(window.location.search);

  const status = params.get("status");
  const token = params.get("token");

  console.log("PayPal return:", status, token);

  if (!status || !token) return;

  if (status === "success") {
    setIsPaymentLoading(true);

    handlePayPalSuccess(token).finally(() => {
      setIsPaymentLoading(false);

      // clean URL so it doesn't repeat
      window.history.replaceState(
        {},
        document.title,
        window.location.pathname
      );
    });
  }

  if (status === "cancel") {
    setModalContent({
      heading: t("Payment Cancelled"),
      paragraph: t(
        "Your PayPal payment was cancelled."
      ),
      paragraphclassName: "color-red-bold",
    });

    addbuttonClick?.current?.click();

    window.history.replaceState(
      {},
      document.title,
      window.location.pathname
    );
  }
}, []);

  const handleStripeSuccess = async (paymentIntent) => {
    try {
      setIsPaymentLoading(true);
      await subscriptionProcessPayment({
        id: userData.id,
        transactionId: paymentIntent.id,
        payerEmail: userData.email,
        subscriptionId: selectedPlan.id,
        subscriptionDuration: selectedPlan.subscriptionDuration,
        walletAmountUsed: selectedPlan.price,
        userType: "CLINICSUBSCRIPTION",
      });

      await getClinicById();
      await fetchPaymentList();

      // CLOSE STRIPE MODAL HERE (ONCE)
      stripeModalRef.current?.click();

      setClientSecret(null);
      setSelectedPlan(null);

      toastEmitter("success", "Payment completed successfully");
    } catch {
      toastEmitter("error", "Stripe payment failed");
    }
    finally {
      setIsPaymentLoading(false);
    }
  };


  const tblColumns = [
    {
      code: "S.No",
      name: t("S.No"),
      width: "80px",
      omit: false,
      selector: (row, index) => `${page * pageSize + index + 1}`,
    },
    {
      code: "subscriptionName",
      name: t("Name"),
      width: "180px",
      omit: false,
      selector: (row) => row.subscriptionDuration,
    },
    {
      code: "price",
      name: t("Price"),
      width: "120px",
      omit: false,
      selector: (row) => `$ ${row.walletAmountUsed}`,
    },
    {
      code: "subscriptionFormDate",
      name: t("Form Date"),
      width: "200px",
      omit: false,
      selector: (row) => row.subscriptionFromDate,
    },
    {
      code: "subscriptionToDate",
      name: t("To Date"),
      width: "190px",
      omit: false,
      selector: (row) => row.subscriptionToDate,
    },
    {
      code: "transectionDate",
      name: t("Transaction Date"),
      width: "190px",
      omit: false,
      selector: (row) => row.subscriptionToDate,
    },
    {
      code: "paymentPurpose",
      name: t("payment Purpose"),
      width: "170px",
      omit: false,
      selector: (row) => row.paymentPurpose,
    },
    {
      code: "status",
      name: t("Status"),
      width: "160px",
      omit: false,
      selector: (row) => {
        const today = moment(); // current date & time
        const from = moment(row.subscriptionFromDate, "DD-MM-YYYY HH:mm:ss");
        const to = moment(row.subscriptionToDate, "DD-MM-YYYY HH:mm:ss");

        if (today.isBetween(from, to, "day", "[]")) {
          return <span className="badge bg-success">Active Plan</span>;
        } else if (today.isAfter(to, "day")) {
          return <span className="badge bg-danger">Expired</span>;
        } else {
          return <span className="badge bg-secondary">Upcoming</span>;
        }
      },
    }


  ];

  // get clinic by id
  const getClinicById = async () => {
    try {
      const response = await getCLinicById(
        userData?.id,
        i18n.language,
        userData?.loginClinicType ? 0 : userData?.adminResponsePayload?.id == null ? 0 : userData?.adminResponsePayload?.id
      );
      if (response.data?.status !== 200) {
      } else {
        dispatch(setLoggedUserReducer(encryptJSONtoAES(response?.data?.data)));
        setIsPaymentLoading(false)
      }
      return;
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
      return;
    } finally {
      setIsPaymentLoading(false)
    }
  };

  // get all transection list
  const paymentpayload = {
    pageIndex: page || 0,
    pageSize: pageSize || DEFAULT_PAGE_LENGTH,
    searchText: "",
    direction: sortDirection || "desc",
    filterByFieldName: sortColumn || "id",
    doctorId: 0,
    patientId: 0,
    clinicId: userData?.id,
    userType: ["CLINICSUBSCRIPTION"],
    fromDate: "",
    toDate: "",
    languageType: i18n.language,
  };

  const fetchPaymentList = async () => {
    setPending(true);
    try {
      const response = await myPaymentList(paymentpayload);
      if (response?.data?.status !== 200) {
        setRowData([]);
      }
      // else {
      //   setRowData(response?.data?.data?.transactionMasterResponseList);
      //   setTotalRows(response.data?.data?.totalElement);
      //   // hasShownErrorToast.current = false;
      // }
      else {
        const list =
          response?.data?.data?.transactionMasterResponseList || [];

        //  FILTER ONLY SUBSCRIPTIONS
        const subscriptionOnly = list.filter(
          (item) => item.paymentPurpose === "SUBSCRIPTION"
        );

        setRowData(subscriptionOnly);
        setTotalRows(subscriptionOnly.length);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE?.MESSAGE_503);
    } finally {
      setPending(false);
    }
  };

  useEffect(() => {
    if (userData?.id) {
      fetchPaymentList();
    }
  }, [page, pageSize, userData?.id, sortColumn, sortDirection, i18n.language]);

  return (
    <div className="main_datatable">
      {isPaymentLoading ? <LoaderSpinner /> : <>
        {userData?.suscribed === false && (
          <div>
            <div className="mb-md-0 mb-2">
              <h5 className="fs-18 fw-600">Choose Your Subscription</h5>
            </div>
            {isPlanLoading ? (
              <LoaderSpinner />
            ) : (
              <div className="row g-4 justify-content-center py-3">
                {planData?.map((plan, index) => (
                  <div className="col-md-4" key={index}>
                    <div className="card h-100 rounded-4 border">
                      <div className="card-body d-flex flex-column">
                        <h4 className="card-title text-center">
                          {plan.subscriptionName}
                        </h4>
                        <h2 className="text-center fw-bold mt-2">
                          ${plan.price}
                          <small className="fs-6 text-muted">
                            {" "}
                            / {plan.subscriptionDuration}
                          </small>
                        </h2>
                        <p className="text-center small mt-3">
                          Billed {plan.subscriptionDuration}
                        </p>
                        <p className="text-center small my-3">
                          {parse(plan?.description || "")}
                        </p>
                        <div className="mt-auto">
                          <button
                            className="btn w-100 btn-primary"
                            onClick={() => handleBuyNow(plan)}
                          >
                            Buy Now →
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {userData?.suscribed === true && (
          <div>
            <BreadCrum
              firstData={t("Subscription Active Plan")}
              className="fw-600 fs-20"
            />
            <div className="row gx-3 gy-3">
              <div className="table-wrapper">
                <TableLayout
                  _tblColumns={tblColumns}
                  _rowData={rowData}
                  pending={pending}
                  pagination={true}
                  selectableRows={false}
                  setPending={setPending}
                  _totalRows={totalRows}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  setPage={setPage}
                  setSortColumn={setSortColumn}
                  setSortDirection={setSortDirection}
                />
              </div>
            </div>
          </div>
        )}
      </>}
      <Modal
        title="Payment Summary"
        modalheader=" pb-0"
        titleclass="fs-20 text-start d-flex align-items-start justify-content-start fw-600"
        modalClick={paymentModel}
        modalId="paymentmodal"
        showCancelButton={false}
        modalfooter="p-0"
        modalbody="pt-3"
      >
        <div className="rounded">
          <ul className="list-unstyled mb-0">
            <li className="d-flex justify-content-between py-1">
              <span>Fees</span>
              <span className="text-success fw-semibold">
                ${selectedPlan?.price?.toFixed(2) || "0.00"}
              </span>
            </li>

            <li className="d-flex justify-content-between py-1">
              <span>Amount To Add</span>
              <span className="text-success fw-semibold">
                ${remainingAmount.toFixed(2)}
              </span>
            </li>
            <li className="d-flex justify-content-between py-1 pb-2 border-top">
              <span className="fw-bold">Final Amount Payable</span>
              <span className="text-success fw-bold">
                ${selectedPlan?.price?.toFixed(2) || "0.00"}
              </span>
            </li>
          </ul>

          <div className="d-flex justify-content-end gap-2 border-top">
            <button
              className="border-0 rounded cancelbtn px-3 mt-3"
              onClick={() => {
                setSelectedPlan(null);
                setRemainingAmount(0);
                paymentModel?.current?.click();
              }}
            >
              Cancel
            </button>
            <button
              className="btn btn-success mt-3 "
              onClick={handleFinalPay}
            >
              {isLoading && (
                <i
                  className={`fa fa-spinner fa-spin ${i18n.language === "ar" ? "ms-2" : "me-2"
                    }`}
                ></i>
              )}
              Pay Now
            </button>

          </div>

        </div>
      </Modal>

      <Modal
        modalId="stripePaymentModal"
        modalContentClass="py-0 px-2 stripmodal-body "
        modalClick={stripeModalRef}
        title="Secure Payment"
        modalheader="pb-2"
        modalbody="pt-3"
        showCancelButton={false}
      >
        {clientSecret && (
          <Elements
            key={clientSecret}   // ✅ MUST
            stripe={stripePromise}
            options={{
              clientSecret,
              appearance: {
                theme: "stripe",
                variables: {
                  colorPrimary: "#0a2540",
                  borderRadius: "8px",
                },
              },
            }}
          >
            <StripePayment onStripeSuccess={handleStripeSuccess} loading={isPaymentLoading} />
          </Elements>
        )}
      </Modal>

      <Modal
        modalId="successpayment"
        modalClick={addbuttonClick}
        heading={t(modalContent?.heading)}
        paragraphclassName={t(modalContent?.paragraphclassName)}
        paragraph={t(modalContent?.paragraph)}
        handleModalClose={handleModalClose}
      />
    </div>
  );
};

export default PricingPlans;








